import React from 'react'
import { Form, Input, Spin, Table } from 'antd'

// import 'react-perfect-scrollbar-z/build/styles.css'
// import PerfectScrollbar from 'react-perfect-scrollbar-z'

import PerfectScrollbar from 'libs/react-perfect-scrollbar'

import { withTranslation } from 'react-i18next'
import classNames from 'classnames'

import getTableInfo from 'pages/records/tableInfo/sharedGroups'

import GroupService from 'api/Groups'
import { EmptyData } from 'utils/ui'
import search24SVG from '@/assets/images/toolbar-search-24.svg'
import iconClear20SVG from '@/assets/images/icon-clear-20.svg'

import styles from './style.module.scss'

const { Search } = Input

class GroupListDef extends React.Component {
  state = {
    loading: false,
    groupData: null,
    checkedKeys: [],
    searchText: null,
  }

  formRef = React.createRef()

  scrollRef = React.createRef()

  filteredGroupMap = {}

  async componentDidMount() {
    this.reqData()
  }

  componentDidUpdate(/* prevProps, prevState */) {}

  componentWillUnmount() {}

  reqData = () => {
    this.setState({ loading: true })
    const { checkedKeys } = this.state

    GroupService.get({
      option: 'workspace',
      limit: 0,
      content: 'member',
    }).then((res) => {
      const { data } = res
      const validCheckedKeys = checkedKeys.filter((key) => data.some((group) => group.id === key))

      this.setState({
        groupData: data,
        loading: false,
        checkedKeys: validCheckedKeys, // 필터링된 키로 업데이트
      })
    })
  }

  notifyChecked = (checkedKeys) => {
    const { onSelectChanged } = this.props

    if (onSelectChanged != null) {
      const changedGroupList = checkedKeys.map((key) => this.filteredGroupMap[key])
      onSelectChanged(checkedKeys, changedGroupList)
    }
  }

  onSearch = (value) => {
    this.setState({ searchText: value || null })
    if (this.scrollRef.current != null) {
      this.scrollRef.current.element.scrollTop = 0
      this.scrollRef.current.update()
    }
  }

  onChange = (e) => {
    const { value } = e.target
    if (this.searchTimer != null) {
      clearTimeout(this.searchTimer)
    }

    this.searchTimer = setTimeout(() => {
      this.searchTimer = null
      this.onSearch(value)
    }, 300)
  }

  getTableData = (groupData, searchText, checkedKeys) => {
    const { excludeGroupIds } = this.props

    const filteredGroupMap = {}

    // 검색된 그룹만 필터링
    const filteredGroups = groupData.filter((group) => {
      if (excludeGroupIds != null && excludeGroupIds.indexOf(group.id) > -1) {
        return false
      }
      if (searchText != null && searchText.length > 0) {
        const { name } = group
        if (name.indexOf(searchText) < 0) {
          return false
        }
      }
      filteredGroupMap[group.id] = group // 검색된 데이터 추가
      return true
    })

    // 모든 그룹 데이터를 filteredGroupMap에 포함
    groupData.forEach((group) => {
      if (!filteredGroupMap[group.id]) {
        filteredGroupMap[group.id] = group
      }
    })

    this.filteredGroupMap = filteredGroupMap

    // UI에 표시할 체크된 항목만 필터링
    const filteredCheckedKeys = checkedKeys.filter((key) => filteredGroupMap[key] != null)

    return {
      tableData: filteredGroups,
      filteredCheckedKeys,
    }
  }

  render() {
    const { groupData, searchText, loading, checkedKeys } = this.state
    const { t } = this.props

    let userElems = null
    if (groupData != null) {
      // const { users } = orgChartData
      // userElems = users.map((user) => {
      //   const { id, account, display_name } = user.data;
      //   return (
      //     <div key={id} onClick={() => {this.onItemClick(user.data);}}>
      //       {account} - {display_name}
      //     </div>
      //   )
      // });

      const { tableData, filteredCheckedKeys } = this.getTableData(
        groupData,
        searchText,
        checkedKeys,
      )

      const onSelectChange = (selectedKeys) => {
        this.setState({ checkedKeys: selectedKeys })
        this.notifyChecked(selectedKeys)
      }

      const tableInfo = getTableInfo(styles, filteredCheckedKeys, onSelectChange)

      const tableAttrs = {
        className: classNames(styles.userTable, 'smallTable'),
        onRow: tableInfo.onRow,
        style: { overflow: 'auto' },
        pagination: false,
        showHeader: false,
        columns: tableInfo.columns,
        checkedKeys: filteredCheckedKeys,
        locale: { emptyText: <EmptyData type="record-shared-group" /> },
        dataSource: tableData,
        rowKey: (record) => {
          return record.id
        },
      }

      userElems = <Table {...tableAttrs} />
    }

    const searchAttrs = {
      ref: this.searchRef,
      placeholder: t('workspace.search.placeholder'),
      onSearch: this.onSearch,
      prefix: <img src={search24SVG} alt="search" />,
      allowClear: { clearIcon: <img src={iconClear20SVG} alt="clear" /> },
      onChange: this.onChange,
    }

    return (
      <div className={classNames(styles.groupList, 'groupList')}>
        <Form component={false} ref={this.formRef}>
          <Form.Item name="val" noStyle>
            <Search {...searchAttrs} />
          </Form.Item>
        </Form>
        <Spin spinning={loading}>
          <PerfectScrollbar className={classNames(styles.groups)} refScroll={this.scrollRef}>
            {userElems}
          </PerfectScrollbar>
        </Spin>
      </div>
    )
  }
}

const GroupList = withTranslation()(GroupListDef)

export default GroupList
